import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, CheckCircle, FileEdit, Star, FolderTree, Users, BookOpen, Mail } from "lucide-react";
import api from "@/lib/api";

const CARDS = [
  { key: "articles_total", label: "Artículos", icon: FileText, to: "/admin/articulos" },
  { key: "articles_published", label: "Publicados", icon: CheckCircle, to: "/admin/articulos" },
  { key: "articles_draft", label: "Borradores", icon: FileEdit, to: "/admin/articulos" },
  { key: "articles_featured", label: "Destacados", icon: Star, to: "/admin/destacados" },
  { key: "categories", label: "Categorías", icon: FolderTree, to: "/admin/categorias" },
  { key: "authors", label: "Autores", icon: Users, to: "/admin/autores" },
  { key: "magazines", label: "Revistas", icon: BookOpen, to: "/admin/revistas" },
  { key: "subscribers", label: "Suscriptores", icon: Mail, to: "/admin/suscriptores" },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data || {})).catch(() => {}); }, []);

  return (
    <div>
      <header className="mb-10">
        <h1 className="font-serif text-4xl tracking-tight">Dashboard</h1>
        <p className="text-sunset-muted text-sm mt-2">Resumen general de la plataforma editorial.</p>
      </header>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {CARDS.map((c) => (
          <Link key={c.key} to={c.to} data-testid={`stat-${c.key}`}
            className="bg-white border border-sunset-border p-6 hover:border-sunset-accent transition-colors group">
            <div className="flex items-center justify-between mb-6">
              <c.icon size={22} className="text-sunset-accent" />
            </div>
            <p className="font-serif text-4xl tracking-tight">{stats[c.key] ?? 0}</p>
            <p className="text-xs uppercase tracking-wider text-sunset-muted mt-2">{c.label}</p>
          </Link>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
        <Link to="/admin/articulos/nuevo" className="bg-sunset-ink text-white p-8 hover:bg-sunset-accent transition-colors">
          <FileText size={24} className="mb-4" />
          <h3 className="font-serif text-2xl mb-1">Crear artículo</h3>
          <p className="text-white/60 text-sm">Publica una nueva historia editorial.</p>
        </Link>
        <Link to="/admin/hero" className="bg-white border border-sunset-border p-8 hover:border-sunset-accent transition-colors">
          <MonitorIcon />
          <h3 className="font-serif text-2xl mb-1 mt-4">Configurar Hero</h3>
          <p className="text-sunset-muted text-sm">Cambia el video, imagen y textos de portada.</p>
        </Link>
      </div>
    </div>
  );
}

function MonitorIcon() {
  return <div className="w-6 h-6 border-2 border-sunset-accent rounded-sm" />;
}
